import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLogoUfo = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 256,
	height: 256,
	fill: "none",
	viewBox: "0 0 256 256",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#34CE72",
		fillRule: "evenodd",
		d: "M128 256c70.692 0 128-57.308 128-128C256 57.308 198.692 0 128 0 57.308 0 0 57.308 0 128c0 70.692 57.308 128 128 128zm97.12-172.2c-6.806-11.776-34.026-9.642-67.722 3.4-14.164-18.112-39.793-23.55-60.182-11.797-20.392 11.756-28.488 36.643-19.854 57.948-28.168 22.633-43.636 45.12-36.828 56.898 9.471 16.386 58.47 5.839 109.442-23.556 50.973-29.395 84.616-66.508 75.144-82.894z",
		clipRule: "evenodd"
	})
});
export default SvgLogoUfo;
